import {BaseContainerModel} from '../../base-container.model';

export class DashboardContainer extends BaseContainerModel {
  status: string;
  totalCount: string;
}
